import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { NavLink, Link } from 'react-router-dom';
import $ from 'jquery';
import StartDatePicker from './StartDatePicker/StartDatePicker';
import EndDatePicker from './EndDatePicker/EndDatePicker';
import Checkbox from '@mui/material/Checkbox';
import lastOperationsIcon from '../../img/last-operations-icon.png';
import transferConfirmation from '../../img/transfer-confirmation.svg';
import Dropdown from '../../../../copms/Dropdown/Dropdown';
import { request } from '../../../../config';
import YesNoModal from "../../../../copms/Modal/YesNoModal";
import { Autocomplete, Radio, TextField } from '@mui/material';
import { getFormatedDate } from '../../../../helpers/fotmatDate';
import ToolTip from '../../../../copms/ToolTip/ToolTip';

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
function saveFile(name, type, data) {
    if (data !== null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

class List extends Component {
    state = {
        status: 1,
        toDate: null,
        fromDate: null,
        invoices: [],
        id: null,
        checkedItems: [],
        selectAllChecked: false,
        verificationOpen: false,
        verificationCode: null,
        statuses: [],
        statusId: null,
        invoiceNumber: '',
        bencName: '',
        open: false,
        item: null,
        payType: null,
        payableAmount: '',
        calculatedAmount: '',
        accountId: null,
        totalAmountWithComission: null,
        commission: null,
        isBlocked: 0,
        invoice: null
    }

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    componentDidMount() {
        this.getStatuses();
        this.getInvoiceList();
    }

    getStatuses = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getStatusesRequestBody = { token: localStorage.getItem('token') }
        fetch(request("invoice/getStatuses", getStatusesRequestBody))
            .then(res => res.text())
            .then((getStatusesResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getStatusesResponse = JSON.parse(getStatusesResponseJSON);
                if (getStatusesResponse.status.statusCode !== 1) {
                    if (getStatusesResponse.status.statusCode === 200) {
                        this.props.logout();
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({ statuses: getStatusesResponse.statuses ? getStatusesResponse.statuses : [] });
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getInvoiceList = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getInvoiceListRequestBody = {
            token: localStorage.getItem('token'),
            fromDate: getFormatedDate(this.state.fromDate, '-'),
            toDate: getFormatedDate(this.state.toDate, '-'),
            statusId: this.state.statusId,
            invoiceNumber: this.state.invoiceNumber.trim()
        }
        fetch(request("invoice/getInvoiceList", getInvoiceListRequestBody))
            .then(res => res.text())
            .then((getInvoiceListResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getInvoiceListResponse = JSON.parse(getInvoiceListResponseJSON);
                if (getInvoiceListResponse.status.statusCode !== 1) {
                    if (getInvoiceListResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getInvoiceListResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({ invoices: getInvoiceListResponse.invoices ? getInvoiceListResponse.invoices : [], checkedItems: [] });
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getFile = (excel) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getFileRequestBody = {
            token: localStorage.getItem('token'),
            invoiceIds: this.state.checkedItems
        }
        fetch(request(`invoice/${excel ? "excelExportInvoices" : "pdfExportInvoices"}`, getFileRequestBody))
            .then(res => res.text())
            .then((getFileResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getFileResponse = JSON.parse(getFileResponseJSON);
                if (getFileResponse.status.statusCode !== 1) {
                    if (getFileResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getFileResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    let arrrayBuffer = base64ToArrayBuffer(getFileResponse.bytes);
                    saveFile(getFileResponse.fileName, `application/${getFileResponse.fileName.substring(getFileResponse.fileName.lastIndexOf('.'))}`, arrrayBuffer);
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    deleteInvoice = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let deleteInvoiceRequestBody = {
            token: localStorage.getItem('token'),
            invoiceId: this.state.invoice.id
        }
        fetch(request("invoice/deleteInvoice", deleteInvoiceRequestBody))
            .then(res => res.text())
            .then((deleteInvoiceResponseJSON) => {
                const JSON = require('true-json-bigint');
                let deleteInvoiceResponse = JSON.parse(deleteInvoiceResponseJSON);
                if (deleteInvoiceResponse.status.statusCode !== 1) {
                    if (deleteInvoiceResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(deleteInvoiceResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                } else {
                    this.getInvoiceList();
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    dropdownItemHandler = (index, invoice) => {
        switch (index) {
            case 2:
                this.setState({ open: true, invoice });
                break;
            default: break;
        }
    }

    handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        const id = parseInt(name, 10);

        this.setState(prevState => {
            let checkedItems = [...prevState.checkedItems];

            if (name === 'selectAll') {
                if (checked) {
                    checkedItems = prevState.invoices.map(item => item.id);
                } else {
                    checkedItems = [];
                }
                return {
                    checkedItems,
                    selectAllChecked: checked,
                };
            } else {
                if (checked) {
                    if (!checkedItems.includes(id)) {
                        checkedItems.push(id);
                    }
                } else {
                    checkedItems = checkedItems.filter(itemId => itemId !== id);
                }
                const allChecked = prevState.invoices.length === checkedItems.length;
                return {
                    checkedItems,
                    selectAllChecked: allChecked,
                };
            }
        });
    };

    render() {
        let { invoices, selectAllChecked, checkedItems, statuses, statusId, fromDate, toDate, invoiceNumber, open } = this.state;
        let { t } = this.props;
        return (
            <>
                <YesNoModal open={open} title={t('Are you sure you want to delete the alias?')} triggerFunc={() => this.deleteInvoice()} onClose={() => this.setState({ open: false })} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('My invoices')}</h2>
                    </div>
                    <Link to='/dashboard/finance/invoices/create' class="dashboard-header-route-button">{t('Create invoice')}</Link>
                </div>
                <div className="dashboard-salary-container flex-wrap">
                    <div className="dashboard-payment-container-data-section">
                        <div className="dashboard-salary-order-container">
                            <div className="dashboard-salary-order-container-box flex-nowrap mt-3">
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Status")}</label>
                                    <Autocomplete
                                        options={statuses}
                                        value={statuses.find(item => item.id == statusId) || null}
                                        onChange={(event, value) => this.setState({ statusId: value?.id })}
                                        getOptionLabel={option => option.name}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Invoice number")}</label>
                                    <TextField value={invoiceNumber} onChange={(e) => /^\d*$/.test(e.target.value) && this.setState({ invoiceNumber: e.target.value })} inputProps={{ maxLength: 13 }} helperText={t('The invoice number must consist of 13 characters')} />
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("Started date")}</label>
                                    <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                        <StartDatePicker value={fromDate} toDate={toDate} name="fromDate" updateDate={this.updateDate} />
                                    </div>
                                </div>
                                <div className="dashboard-salary-order-container-box-select">
                                    <label>{t("expiration date")}</label>
                                    <div className="dashboard-salary-order-container-box-select-datepicker-input">
                                        <EndDatePicker value={toDate} fromDate={fromDate} name="toDate" updateDate={this.updateDate} />
                                    </div>
                                </div>
                            </div>
                            <div className="dashboard-salary-order-container-box justify-content-end">
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" disabled={invoiceNumber && invoiceNumber.length !== 13} onClick={this.getInvoiceList}>{t("Search")}</button>
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline" onClick={() => this.setState({ statusId: null, invoiceNumber: '', fromDate: null, toDate: null })}>{t("Clear")}</button>
                            </div>
                            {invoices.length === 0 ?
                                <div className="dashboard-last-operations-section-content" style={{ justifyContent: 'center' }}>
                                    <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                    <p className="dashboard-last-operations-section-content-status">{t('you do not currently have any active transactions')}</p>
                                </div>
                                : <><div style={{ height: "40vh", overflowY: "auto", overflowX: 'auto', width: "100%" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead style={{ position: 'sticky', top: 0, left: 0, zIndex: '100' }}>
                                            <tr className='border-0'>
                                                <th>
                                                    <Checkbox
                                                        name="selectAll"
                                                        checked={selectAllChecked}
                                                        onChange={this.handleCheckboxChange}
                                                        inputProps={{ "aria-label": "controlled" }}
                                                        sx={{ color: "#DADADA", "&.Mui-checked": { color: "#0179D2" } }}
                                                    />
                                                </th>
                                                <th>{t("date")}</th>
                                                <th>{t("Invoice number")}</th>
                                                <th>{t("Status")}</th>
                                                <th>{t("Amount")}</th>
                                                <th>{`${t('Commission')} (1%)`}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoices.map(item => (
                                                <tr>
                                                    <td>
                                                        <Checkbox
                                                            checked={checkedItems.includes(item.id)}
                                                            onChange={this.handleCheckboxChange}
                                                            name={item.id.toString()}
                                                            inputProps={{ "aria-label": "controlled" }}
                                                            sx={{ color: "#DADADA", "&.Mui-checked": { color: "#0179D2" } }}
                                                        />
                                                    </td>
                                                    <td>{item.dataDate ? getFormatedDate(item.dataDate, 'dd.mm.yyyy') : '--'}</td>
                                                    <td>{item.invoiceNumber || '--'}</td>
                                                    <td style={{ minWidth: '173px' }}>
                                                        <div style={{ display: 'ruby' }}>
                                                            <span style={{ width: '8px', height: '8px', display: 'inline-block', marginRight: 7, borderRadius: '50%', backgroundColor: item?.statusId == 1 ? "#276EF1" : item?.statusId == 3 ? "#FF3A3A" : item?.statusId == 2 ? "#39C045" : "#FFAB24" }}></span>
                                                            {item.statusName || '--'}
                                                            {(item.deleted == 1 || item.expired == 1) &&
                                                                <ToolTip name={item.deleted == 1 ? this.props.t('The invoice has been deleted by the merchant') : this.props.t('Expired')} />
                                                            }
                                                        </div>
                                                    </td>
                                                    <td>{item.totalAmount || '--'} AZN</td>
                                                    <td>{item.feeAmount || '--'} AZN</td>
                                                    <td>
                                                        <div className="dashboard-finance-section-cards-section-button-group">
                                                            <Dropdown className="center"
                                                                dropdownItems={
                                                                    item.statusId == 1
                                                                        ? [
                                                                            { title: this.props.t('View'), url: '/dashboard/finance/invoices/list/' + item.id },
                                                                            { title: this.props.t('Update'), url: "/dashboard/finance/invoices/edit/" + item.id },
                                                                            { title: this.props.t('Delete') }
                                                                        ] :
                                                                        [
                                                                            { title: this.props.t('View'), url: '/dashboard/finance/invoices/list/' + item.id }
                                                                        ]
                                                                }
                                                                dropdownItemHandler={(i) => this.dropdownItemHandler(i, item)} />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                    <div className="dashboard-salary-order-container-box justify-content-end">
                                        <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" disabled={!checkedItems.length} onClick={() => this.getFile()}>{t("Download PDF")}</button>
                                        <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" disabled={!checkedItems.length} onClick={() => this.getFile(true)}>{t("Download Excel")}</button>
                                    </div></>
                            }
                        </div>
                    </div>
                    <div className="dashboard-payment-container-confirmation-section">
                        <div className="dashboard-payment-container-confirmation-section-header">
                            <h3 className="dashboard-payment-container-confirmation-section-header-title">{t('Invoice services')}</h3>
                        </div>
                        <div className="dashboard-payment-container-confirmation-section-content">
                            <img src={transferConfirmation} alt="img" className="dashboard-payment-container-confirmation-section-content-image" />
                            <div className="dashboard-payment-container-confirmation-section-content-description">
                                <p>{t('invoice text')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default translate("translation")(List);